import React from "react";

const Alert = ({ value }) => {
  return <div className="floating">{value} is copied!</div>;
};

export default Alert;
